export default __webpack_public_path__ + "static/media/Subject_Matter_Expert_Role.9f04bdc5.svg";